export default () =>
  import(
    /* webpackChunkName: 'coffee/app/help-centre/dispatche' */ './HelpCentre'
  );
